module.exports = __webpack_public_path__ + "static/media/upgrade-power.ce375dcc.jpg";